module.exports = __webpack_public_path__ + "static/media/simple-settings.938184c0.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/pages/home/sections/marketingPoints/assets/simple-settings.png
 ** module id = 573
 ** module chunks = 0
 **/